import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  icon: "",
  mainWebDisplayText: "",
  mainId: "",
  subServiceId: "",
  displayText: "",
  isCrps: null
};

export const serviceSlice = createSlice({
  name: "service",
  initialState,
  reducers: {
    changeIconAndMainWebText: (state, action) => {
      const { icon, mainWebDisplayText } = action.payload;
      state.icon = icon;
      state.mainWebDisplayText = mainWebDisplayText;
    },
    changeSubServiceInfo: (state, action) => {
      const { mainId, subServiceId, displayText, isCrps, isExperience } =
        action.payload;
      state.mainId = mainId;
      state.subServiceId = subServiceId;
      state.displayText = displayText;
      state.isCrps = isCrps;
      state.isExperience = isExperience;
    },
    changeOtpAppointmentExistence: (state, action) => {
      const { mainId, subServiceId, mainWebDisplayText } = action.payload;
      state.mainId = mainId;
      state.subServiceId = subServiceId;
      state.mainWebDisplayText = mainWebDisplayText;
    },
    clearServices: (state) => {
      state.icon = "";
      state.mainWebDisplayText = "";
      state.mainId = "";
      state.subServiceId = "";
      state.displayText = "";
      state.isCrps = null;
    },
    updateServices: (state, action) => {
      const {
        service_id,
        sub_service_id,
        icon,
        web_disp_text,
        sub_web_disp_text
      } = action.payload;
      state.icon = icon;
      state.mainWebDisplayText = web_disp_text;
      state.mainId = service_id;
      state.subServiceId = sub_service_id;
      state.displayText = sub_web_disp_text;
    }
  }
});

export const {
  changeIconAndMainWebText,
  changeSubServiceInfo,
  clearServices,
  changeOtpAppointmentExistence,
  updateServices
} = serviceSlice.actions;

export default serviceSlice.reducer;
